(() => {
  if (customElements.get('net-wishlist-toggle')) return;
  const key = 'wishListsArr';
  const read = () => {
    const items = JSON.parse(localStorage.getItem(key) || '[]');
    if (!Array.isArray(items) || items.some(item => typeof item !== 'string' || !item)) throw new Error('storage');
    return [...new Set(items)];
  };
  class WishlistToggle extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const button = this.querySelector('button');
      if (!button) return;
      const sync = () => {
        try {
          const saved = read().includes(this.dataset.handle);
          button.setAttribute('aria-pressed', String(saved));
          button.setAttribute('aria-label', saved ? button.dataset.remove : button.dataset.add);
          button.title = button.getAttribute('aria-label');
        } catch (_) { }
      };
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element) || !event.target.closest('button')) return;
        event.preventDefault();
        event.stopPropagation();
        try {
          const items = read();
          const handle = this.dataset.handle;
          if (!handle) return;
          const next = items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle];
          localStorage.setItem(key, JSON.stringify(next));
          if (!items.includes(handle)) {
            try {
              const result = window.Shopify?.analytics?.publish(
                'net_wishlist_added',
                {
                  product_handle: handle,
                  product_id: this.dataset.productId,
                  product_title: this.dataset.productTitle,
                  product_type: this.dataset.productType,
                  vendor: this.dataset.vendor,
                  product_url: new URL(this.dataset.productUrl || `/products/${encodeURIComponent(handle)}`, location.origin).href,
                  rendered_variant_id: this.dataset.variantId,
                  rendered_variant_title: this.dataset.variantTitle,
                  value: this.dataset.price?.trim() && Number.isFinite(Number(this.dataset.price)) && Number(this.dataset.price) >= 0
                    ? Number(this.dataset.price) : undefined,
                  currency: this.dataset.currency,
                  quantity: 1,
                  page_type: document.querySelector('main[data-template]')?.dataset.template,
                }
              );
              Promise.resolve(result).catch(() => {});
            } catch (_) {
              // Tracking failure must not interrupt wishlist behavior.
            }
          }
          const status = this.querySelector('[role=status]');
          if (status) status.textContent = '';
          document.dispatchEvent(new CustomEvent('net:wishlist-change'));
        } catch (_) {
          const status = this.querySelector('[role=status]');
          if (status) status.textContent = button.dataset.error;
        }
      }, options);
      document.addEventListener('net:wishlist-change', sync, options);
      window.addEventListener('storage', event => {
        if (event.key === key || event.key === null) sync();
      }, options);
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('net-wishlist-toggle', WishlistToggle);
})();
